import { TestStep } from "../models/testStep";
import { ElectronicsConfiguration } from "../models/electronicsConfiguration";
import { MeasureVoltage } from "../models/testSteps/measureVoltage";
import { MeasureCurrent } from "../models/testSteps/measureCurrent";
import { SwitchRelais } from "../models/testSteps/switchRelais";
import { ExternalCommand } from "../models/testSteps/externalCommand";
import { StLink } from "../models/testSteps/stLink";
import { UserInput } from "../models/testSteps/userInput";
import { TestProcedure } from "../models/testProcedure";

export const isStepValid = (step: TestStep, config: ElectronicsConfiguration): boolean => {
  if (!step.name || step.name.trim() === "") return false;

  if (step.type === "MeasureVoltage") {
    const s = step as MeasureVoltage;
    if (!s.voltage_id || !config.signal_mapping.voltage.some(v => v.id === s.voltage_id)) return false;
    if (s.enable_min && s.min === undefined) return false;
    if (s.enable_max && s.max === undefined) return false;
  }

  if (step.type === "MeasureCurrent") {
    const s = step as MeasureCurrent;
    if (!s.current_id || !config.signal_mapping.current.some(c => c.id === s.current_id)) return false;
    if (s.enable_min && s.min === undefined) return false;
    if (s.enable_max && s.max === undefined) return false;
  }

  if (step.type === "SwitchRelais") {
    const s = step as SwitchRelais;
    if (!s.relais_id || !config.signal_mapping.relais.some(r => r.id === s.relais_id)) return false;
  }

  if (step.type === "StLink") {
    const s = step as StLink;
    if (!s.firmware_data || !s.firmware_path) return false;
  }

  if (step.type === "ExternalCommand") {
    const s = step as ExternalCommand;
    if (!s.exec || s.exec.trim() === "") return false;
  }

  if (step.type === "ManualBool" || step.type === "ManualChoice") {
    const s = step as UserInput;
    if (!s.text) return false;
  }

  return true;
};

export const isProcedureValid = (procedure: TestProcedure, config: ElectronicsConfiguration): boolean => {
  return procedure.steps.every(step => isStepValid(step, config));
};
